export enum ProgressStepsBackgroundColor {
  DEFAULT = 'default',
  DARK = 'dark',
}

export enum ProgressStepsType {
  NUMBER = 'number',
  DOT = 'dot',
}
